<template>
  <div class="pt-10 px-6 pb-20 body">
    <div class="mb-6">
      <TextField type="password" label="Password Saat Ini" v-model="payload.currentPassword" :error="errors['currentPassword']" placeholder="Masukan password saat ini" />
    </div>
    <div class="mb-6">
      <TextField type="password" label="Password Baru" v-model="payload.newPassword" :error="errors['newPassword']" placeholder="Silahkan masukan password baru kamu" />
    </div>
    <div class="mb-6">
      <TextField
        type="password"
        label="Konfirmasi Password Baru"
        v-model="payload.newPasswordConfirmation"
        :error="errors['newPasswordConfirmation']"
        placeholder="Silahkan masukan password baru kamu"
      />
    </div>

    <div class="px-6 pb-6 bg-white fixed bottom-0 left-0 z-1 w-full">
      <Button buttonText="Update" size="full" @action="update()" />
    </div>
  </div>
</template>
<script>
import { isNotEmptyError } from '@/util/form-validator'
import { mapActions } from 'vuex'
const CONFIG = {
  currentPassword: 'Password Saat Ini',
  newPassword: 'Password Baru',
  newPasswordConfirmation: 'Konfirmasi Password Baru'
}
export default {
  components: {
    TextField: () => import('@/components/Forms/TextField'),
    Button: () => import('@/components/Forms/Button')
  },
  data() {
    return {
      payload: {
        currentPassword: null,
        newPassword: null,
        newPasswordConfirmation: null
      },
      errors: []
    }
  },
  methods: {
    ...mapActions('auth', ['changePassword']),
    ...mapActions('common', ['showLoading', 'hideLoading', 'setToast']),
    update() {
      if (this.validForm()) {
        if (this.payload.newPassword !== this.payload.newPasswordConfirmation) {
          this.errors['newPasswordConfirmation'] = 'Konfirmasi password tidak sesuai'
          return
        }
        this.showLoading()
        const requestBody = {
          password: this.payload.currentPassword,
          new_password: this.payload.newPassword,
          confirm_new_password: this.payload.newPasswordConfirmation
        }
        this.changePassword({
          payloads: requestBody
        }).then(() => {
          this.hideLoading()
          this.setToast({
            options: { type: 'success', duration: 2000, primaryText: 'Password Berhasil Diubah', secondaryText: 'Data telah kami simpan', callback: this.handleCallback }
          })
        })
      }
    },
    handleCallback() {
      this.$emit('dismiss')
    },
    validForm() {
      const error = isNotEmptyError(this.payload)
      this.errors = error.reduce(function(map, obj) {
        map[obj.field] = CONFIG[obj.field] + ' ' + obj.error
        return map
      }, {})
      return Object.keys(this.errors).length === 0
    }
  }
}
</script>
<style lang="scss" scoped>
.body {
  height: calc(100% - 52px);
}
</style>
